'use client';

import { CloseIcon } from '@insta-club/components';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface Props {
    onClick?: () => void;
}

export default function CloseBtn({ onClick }: Props) {
    const [showText, setShowText] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setShowText(false), 3500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <motion.div
            onClick={onClick}
            layout
            initial={{ scale: 1 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className='flex cursor-pointer items-center overflow-hidden rounded-full bg-white shadow-sm'
        >
            <motion.div layout className='flex h-7 w-7 items-center justify-center rounded-full bg-white'>
                <CloseIcon width={10} height={10} />
            </motion.div>

            <AnimatePresence initial={false}>
                {showText && (
                    <motion.div
                        layout
                        initial={{ opacity: 0, x: -5 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -5 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        className='overflow-hidden pe-3'
                    >
                        <span className='text-xs font-bold whitespace-nowrap'>بستن</span>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}

